module.exports = __webpack_public_path__ + "static/img/medical.b38b791.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/medical.png
// module id = 7d6l
// module chunks = 1